if (location.pathname.match("/history/")) {

    let history = document.querySelectorAll(".years__rowsRow"),
        btncells = document.querySelectorAll(".years__cellsCell")
    let years = []

    btncells.forEach((elm) => {
        years.push(elm.dataset.when)
    })

    years.sort()

    btncells.forEach((cell) => {
        cell.addEventListener("click", (e) => {

            let num = years.indexOf(cell.dataset.when)
            if (years[num + 1] == null) {
                changeHistory(years[num], 3000)
            } else {
                changeHistory(years[num], years[num + 1])
            }

            btncells.forEach((othercells) => {
                othercells.classList.remove("crnt")
            })
            cell.classList.add("crnt")

            let rowsLine = document.querySelector(".years__rowsLine"),
                nowHistory = document.querySelectorAll(".years__rowsRow:not(.disable)")

            if (nowHistory.length != 0) {
                let lastHis = nowHistory[nowHistory.length - 1].getBoundingClientRect(),
                    firstHis = nowHistory[0].getBoundingClientRect()

                rowsLine.style.height = ((lastHis.top - firstHis.top) / window.innerWidth * 100) + "vw"
            } else {
                rowsLine.style.height = "0vw"
            }
        })
    })

    function changeHistory(start, end) {
        history.forEach(elm => {
            if (elm.dataset.year >= start && elm.dataset.year < end) {
                elm.classList.remove("disable")
            } else {
                elm.classList.add("disable")
            }
        })
    }

    changeHistory(years[0], years[1])
    window.addEventListener("load", () => {
        btncells[0].dispatchEvent(new Event("click"))
    })
}